var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_17003)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.186 0.842441C4.14146 0.755509 4.0738 0.682554 3.99046 0.631611C3.90712 0.580667 3.81134 0.553711 3.71366 0.553711C3.61599 0.553711 3.5202 0.580667 3.43686 0.631611C3.35353 0.682554 3.28586 0.755509 3.24133 0.842441L0.322398 6.6803C0.281687 6.76107 0.262304 6.85092 0.26609 6.94136C0.269876 7.03174 0.296706 7.11962 0.344031 7.19674C0.391356 7.27385 0.457606 7.33759 0.53649 7.38185C0.61537 7.42616 0.704265 7.44957 0.794736 7.44983H6.63258C6.72306 7.44957 6.81196 7.42616 6.89082 7.38185C6.96974 7.33759 7.03597 7.27385 7.08331 7.19674C7.1306 7.11962 7.15745 7.03174 7.16122 6.94136C7.16504 6.85092 7.14562 6.76107 7.10491 6.6803L4.186 0.842441Z",
    stroke: "#FFBE00",
    strokeWidth: 0.530714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71289 2.93848V4.6633",
    stroke: "#FFBE00",
    strokeWidth: 0.530714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71471 6.12278C3.64143 6.12278 3.58203 6.06339 3.58203 5.9901C3.58203 5.91681 3.64143 5.85742 3.71471 5.85742",
    stroke: "#FFBE00",
    strokeWidth: 0.530714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71484 6.12278C3.78812 6.12278 3.84752 6.06339 3.84752 5.9901C3.84752 5.91681 3.78812 5.85742 3.71484 5.85742",
    stroke: "#FFBE00",
    strokeWidth: 0.530714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_17003"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.43,
    height: 7.43,
    fill: "white",
    transform: "translate(0 0.285156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.4172e30c2c20f63c2e651c7f0a70732e.svg";
export { ForwardRef as ReactComponent };